/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} My_Grower_Report_YearInputs */

const vi_my_grower_report_year = /** @type {(inputs: My_Grower_Report_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Năm ${i?.year}`)
};

/**

* @param {My_Grower_Report_YearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_year = /** @type {((inputs: My_Grower_Report_YearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_YearInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_year(inputs)
});